import { Message } from "primereact/message";

export default function NoObjectsMessage() {

    const messageContent = (
        <div className="message-content">
            <i className="pi pi-info-circle" /> <span>Нет доступных объектов</span>
        </div>
    );

    return (
        <Message
            className="no-objects-message"
            severity={undefined}
            content={messageContent}
        />
    )
}
